var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"fluid":""}},[_c('div',{staticClass:"main"},[_c('h1',{staticClass:"header"},[_vm._v("Usuário sem permissão para acessar este modulo!")]),_c('p',{staticClass:"text"},[_vm._v("Contate o administrador para mais detalhes...")])])])
}]

export { render, staticRenderFns }